import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    tituloEstudoResponsabilidadeCliente,
    tituloEstudoResponsabilidadeConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    capitalize,
} from '../../../business-components/String/String'

import {
    
 } from '../../../business-components/Grid/Grid'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

 import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconDiaDiaDespesasTemporarias,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormDespesasDiaDiaDespesasTemporarias = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } )  => {
    
    const DespesasDiaDiaDespesasTemporarias = () => {

        let headList = [
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoDiaDia, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.grupoDespesa, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensal, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.mesAnoInicial, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.mesAnoFinal, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(capitalize(LABELESPECIAL.meses), report),
            },
        ]

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeCliente(values), report
                            ),
                },
            )
        }
    
        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeConjuge(values), report
                            ),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.diaDiaDespesasTemporarias?.map((item, ind) => {

                        let colSpan = 0
    
                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.descricaoGrupoDespesa}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorMensal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.mesAnoInicial}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.mesAnoFinal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.tempo}
                                </TableCellBodyExibeDados>

                                {dadosCompletosCliente(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorResponsabilidadeCliente}
                                    </TableCellBodyExibeDados>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorResponsabilidadeConjuge}
                                    </TableCellBodyExibeDados>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }
    
    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                    //    className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                    <>
                        <div
                            className={CLASSNAME().formataReportDetalhamento}
                            align='left'
                        >
                            {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoDiaDiaDespesasTemporariasTextoCabecalho
                                ?
                                    <>
                                        {jsonConfiguracao.estudoReportDetalhamentoDiaDiaDespesasTemporariasTextoCabecalho}
                                        <br/>
                                        <br/>
                                        <br/>
                                    </>
                                :
                                    MESSAGE().estudoReportDetalhamentoDiaDiaDespesasTemporariasTextoCabecalho
                            }
                        </div>

                        <DespesasDiaDiaDespesasTemporarias />
                    </>
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconDiaDiaDespesasTemporarias}
                        label={LABEL.diaDiaDespesasTemporarias}
                        helpTextMorte={HELPTEXT.estudoDiaDiaDespesasTemporariasMorte}
                        helpTextInvalidez={HELPTEXT.estudoDiaDiaDespesasTemporariasInvalidez}
                        component={<DespesasDiaDiaDespesasTemporarias/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormDespesasDiaDiaDespesasTemporarias